
import Vue, { PropType } from 'vue';
import { CvAccordion, CvAccordionItem } from '@carbon/vue';
import {
  PdpChoicesSetterType,
  PriceDetailsSetterType,
} from '@/setters/typings';
import { ProductPrintData } from '@midocean/webapps-shared-domain';
import { ProductPrintPositionSetterType } from '@/setters/typings/common/ProductPrintPositionSetterType';
import { mapActions, mapState } from 'pinia';
import { useStore as useProductStore } from '@/stores/product';
import { useStore as useColorManagementStore } from '@/stores/colorsManagement';
export default Vue.extend({
  components: {
    CvAccordion,
    CvAccordionItem,
  },
  props: {
    lang: {
      type: String,
      default: 'en',
    },
    pricingData: {
      type: Object as PropType<PriceDetailsSetterType>,
      required: true,
    },
    pdpChoicesData: {
      type: Object as PropType<PdpChoicesSetterType>,
      required: true,
    },
    productPrintData: {
      type: Object as PropType<ProductPrintData>,
      required: true,
    },
  },

  data() {
    return {
      printTechniqueNames: [] as string[],
    };
  },
  computed: {
    ...mapState(useProductStore, ['unavailablePrintPositions', 'data']),
    totalQuantity(): number {
      return this.pdpChoicesData.productVariants
        .map((v) => v.quantity)
        .reduce((prev, current) => prev + current);
    },
  },
  methods: {
    ...mapActions(useColorManagementStore, ['getPmsColorByPrintPositionId']),
    getNumberOfColours(position: ProductPrintPositionSetterType): string {
      const productPrintPosition = this.data.productPrintPositions.find(
        (p) => p.name === position.printPositionSAPCode
      );
      const technique = productPrintPosition?.printTechniques.find(
        (technique) => {
          return (
            technique.printTechnique.code === position.printTechniqueSAPCode
          );
        }
      );

      const finalResult = +position.numberOfColors || 0;
      const textToReturn = technique?.printTechnique.isFullColor
        ? `${this.$t('print-position.full-colour')}`
        : `${this.$tc('print-position.number-colours', finalResult, {
            number: finalResult,
          })}`;

      return textToReturn;
    },
    getPrintTechniqueSAPCode(position: ProductPrintPositionSetterType): string {
      const printPosition = this.unavailablePrintPositions.find(
        (p) => p.printPositionSAPCode === position.printPositionSAPCode
      );

      return printPosition?.technique.printTechniqueSAPCode as string;
    },
  },
});
